import React from "react";
import { Inbox, RefreshCw, AlertTriangle } from "lucide-react";
import { Skeleton } from "./ui/skeleton";

/* 统一空状态：图标 + 一句话 + 可选主操作 */
export const EmptyState = ({ icon: Icon = Inbox, title, hint, action, compact, testId = "empty-state", className = "" }) => (
  <div data-testid={testId} className={`flex flex-col items-center justify-center text-center ${compact ? "py-6 px-3" : "py-12 px-4"} ${className}`}>
    <span className={`rounded-2xl bg-slate-100 text-slate-500 flex items-center justify-center ${compact ? "h-9 w-9" : "h-12 w-12"}`}><Icon className={compact ? "h-4 w-4" : "h-6 w-6"} /></span>
    <p className={`mt-3 font-semibold text-slate-700 ${compact ? "text-sm" : "text-base"}`}>{title}</p>
    {hint && <p className="mt-1 text-sm text-slate-500 max-w-md leading-relaxed">{hint}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

/* 统一错误提示：一句话 + 重试 */
export const ErrorState = ({ title, detail, onRetry, zh = true, testId = "error-state" }) => (
  <div data-testid={testId} role="alert" className="flex flex-col sm:flex-row items-start sm:items-center gap-3 rounded-2xl border border-rose-200 bg-rose-50/70 px-4 py-3">
    <span className="h-9 w-9 rounded-xl bg-rose-100 text-rose-700 flex items-center justify-center shrink-0"><AlertTriangle className="h-4 w-4" /></span>
    <div className="flex-1 min-w-0">
      <p className="text-sm font-semibold text-rose-800">{title || (zh ? "加载失败" : "Failed to load")}</p>
      {detail && <p className="text-xs text-rose-700/90 break-words mt-0.5">{detail}</p>}
    </div>
    {onRetry && <button type="button" data-testid={`${testId}-retry`} onClick={onRetry} className="inline-flex items-center gap-1 rounded-xl border border-rose-300 bg-white px-3 py-1.5 text-xs font-semibold text-rose-700 hover:bg-rose-100"><RefreshCw className="h-3.5 w-3.5" />{zh ? "重试" : "Retry"}</button>}
  </div>
);

/* 表格骨架屏：替代「加载中…」转圈 */
export const TableSkeleton = ({ rows = 6, cols = 5, testId = "table-skeleton" }) => (
  <div data-testid={testId} aria-busy="true" className="w-full">
    <div className="flex gap-3 px-4 py-3 border-b border-slate-100">{Array.from({ length: cols }).map((_, i) => <Skeleton key={i} className="h-3 rounded" style={{ width: `${i === 0 ? 22 : 12 + (i * 7) % 14}%` }} />)}</div>
    {Array.from({ length: rows }).map((_, r) => (
      <div key={r} className="flex items-center gap-3 px-4 py-3 border-b border-slate-50">
        {Array.from({ length: cols }).map((_, i) => <Skeleton key={i} className="h-3.5 rounded" style={{ width: `${i === 0 ? 24 : 10 + ((i + r) * 5) % 16}%`, opacity: 1 - r * 0.08 }} />)}
      </div>
    ))}
  </div>
);

/* 卡片骨架屏（KPI / 看板卡） */
export const CardSkeleton = ({ count = 4, className = "", testId = "card-skeleton" }) => (
  <div data-testid={testId} aria-busy="true" className={`grid gap-4 ${className || "grid-cols-2 lg:grid-cols-4"}`}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="rounded-2xl border border-slate-200 bg-white p-4 space-y-3">
        <Skeleton className="h-3 w-1/2 rounded" /><Skeleton className="h-7 w-2/3 rounded" /><Skeleton className="h-3 w-3/4 rounded" />
      </div>
    ))}
  </div>
);
